import React, { useState, useEffect } from "react";
import { fetchBusinessShowroom } from "@Services/api";
import qs from "qs";
import GoogleMap from "@Components/business/GoogleMap";
import withLayout from "../../layouts/withLayout";
import { Breadcrumb } from "antd";
import { createGlobalStyle } from "styled-components";
import { setUrlFormat } from "@Lib/common";

interface IParams {
  id: any;
  limit: number;
}
interface IData {
  name: string;
  address: string;
  longitude: number;
  latitude: number;
}

const GlobalStyle = createGlobalStyle`
  .ant-breadcrumb{
    font-size: 14px;
    color: #333333;
    padding-top: 20px;
    width: 1190px;
    margin: 0 auto;
  }
  .ant-breadcrumb-separator {
    color: #333;
    margin: 0;
  }
  .ant-breadcrumb-link{
     color: #333 !important;
  }
`;

async function fetchData(params: IParams, setData: React.Dispatch<React.SetStateAction<IData>>) {
  const res = await fetchBusinessShowroom(params);
  setData(res.data);
}

const AgentMap = () => {
  const [data, setData] = useState<IData>({
    name: "",
    address: "",
    longitude: 0,
    latitude: 0,
  });
  const { search } = location;
  const { id } = qs.parse(search, { ignoreQueryPrefix: true });

  useEffect(() => {
    fetchData({ id: id, limit: 20 }, setData);
  }, []);

  return (
    <section className='bg-[#F4F4F4] w-full pb-40'>
      <GlobalStyle />
      <Breadcrumb separator='>'>
        <span className="text-[#333] text-14">您當前的位置：</span>
        <Breadcrumb.Item href='https://www.8891.com.tw/'>
          首頁
        </Breadcrumb.Item>
        <Breadcrumb.Item href='/Models'>
          找車
        </Breadcrumb.Item>
        <Breadcrumb.Item href={`/Models/${setUrlFormat(window.BRAND_NAME)}`}>
          {window.BRAND_NAME}
        </Breadcrumb.Item>
        {!!window.KIND_NAME ? <>
          <Breadcrumb.Item href={`/kind-summary/${window.query_kind_id}`}>
            {window.KIND_NAME}
          </Breadcrumb.Item>
          <Breadcrumb.Item href={`/${setUrlFormat(window.BRAND_NAME)}/${setUrlFormat(window.KIND_NAME)}/showroom`}>
            展示間
          </Breadcrumb.Item>
        </> : null}

        <Breadcrumb.Item>
          地圖
        </Breadcrumb.Item>
      </Breadcrumb>

      <div className='w-1190 mt-20 mx-auto pb-40 bg-[#fff]'>
        <div className='text-[#333333] text-24 border-0 border-b-1 border-solid border-[#E8E8E8] font-medium h-80 flex items-center justify-center'>
          {data.name}
        </div>
        <div className='text-14 text-[#333] mx-40 my-20 flex items-center'>
          <img src='https://assets.8891.com.tw/test-1/public/business/icon_5.png' alt='' className='w-14 h-14 mr-4' />
          {data.address}
        </div>
        {data.latitude !== 0 && (
          <GoogleMap
            latitude={data.latitude}
            longitude={data.longitude}
            css={{ width: "1116px", height: "744px", margin: "0 auto" }}
          />
        )}
      </div>
    </section>
  );
};

withLayout({
  cmp: <AgentMap />,
  params: {
    needRTBH: true,
    AdTopBanner: true,
    nav: "",
    footer: "Footer",
  },
});
